export default "/assets/modules/images/circles-background.png?7ae7957f1b152cdfbef2f5bb362b6b52";